import React, { useState, useEffect, useRef } from "react";
import {
  View,
  TextInput,
  Animated,
  StyleSheet,
  TextInputProps,
} from "react-native";
import type { KeyboardTypeOptions, TextInput as RNTextInput } from "react-native";
import Colors from "../../../constants/colors";

type Props = {
  label?: string;
  value?: string;
  isAutoFocus?: boolean;
  testID?: string;
//   inputRef?: React.RefObject<RNTextInput>;
  onChangeText: (text: string) => void;
  editable?: boolean;
  isKeyboardType?: KeyboardTypeOptions | undefined;
};

const FloatingTextInputComponent: React.FC<Props> = ({
  label,
  value,
  isAutoFocus,
  isKeyboardType,
  testID,
//   inputRef,
  onChangeText,
  editable = true,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const animated = useRef(new Animated.Value(value ? 1 : 0)).current;

  useEffect(() => {
    Animated.timing(animated, {
      toValue: isFocused || value ? 1 : 0,
      duration: 150,
      useNativeDriver: false,
    }).start();
  }, [isFocused, value]);

  const labelStyle = {
    position: "absolute" as const,
    left: 12,
    top: animated.interpolate({
      inputRange: [0, 1],
      outputRange: [18, 6], // from center to top
    }),
    fontSize: animated.interpolate({
      inputRange: [0, 1],
      outputRange: [16, 14],
    }),
    color: animated.interpolate({
      inputRange: [0, 1],
      outputRange: [Colors.subTitleColor, Colors.black], // gray to primary
    }),
  };

  const containerBorderColor= isFocused ? Colors.black : Colors.textInputBackground
  return (
    <View style={styles.container}>
      <Animated.Text style={labelStyle}>{label}</Animated.Text>
      <TextInput
        testID={testID}
        autoFocus={isAutoFocus}
        value={value}
        style={[styles.input, {borderColor: containerBorderColor}, { borderWidth: isFocused ? 1 : { outlineWidth: 0 } as any}]}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChangeText={onChangeText}
        editable={editable}
        keyboardType={isKeyboardType}
      />
    </View>
  );
};

export default FloatingTextInputComponent;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: "relative",
    marginVertical: 8,
    borderRadius: 8,
    backgroundColor: Colors.textInputBackground,
  },
  input: {
    width: '100%',
    height: 56,
    borderRadius: 8,
    fontSize: 16,
    fontWeight: '400',
    fontFamily: 'Rubik',
    lineHeight: 24,
    paddingHorizontal: 12,
    paddingTop: 8,
    ...( { outlineWidth: 0 } as any ),
  },
});